module.exports = __webpack_public_path__ + "43c745b15202129d760996a716497d74.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-dark.png
// module id = 2681
// module chunks = 0